import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8080";

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const signupAPI = {
  // Check system status - returns availability for signup
  checkStatus: () => api.get("/signup/status"),
  
  // Create checkout session - returns Stripe session ID
  createCheckoutSession: (data) => api.post("/signup/create-checkout-session", data),
  
  // Join waitlist when signups are paused
  joinWaitlist: (data) => api.post("/signup/waitlist", data),

  // Verify signup after successful payment
  verifySession: (sessionId) => api.get(`/signup/verify-session/${sessionId}`),
  
  // Resend verification email
  resendVerificationEmail: (sessionId) => api.post(`/signup/resend-verification-email`, { sessionId }),
  
  // Update email address (if typo during signup)
  updateEmail: (sessionId, newEmail) => api.post(`/signup/update-email`, { sessionId, email: newEmail }),

  // Real-time availability checks
  checkEmail: (email, options) => api.post("/signup/check-email", { email }, options),
  checkPhone: (phone, options) => api.post("/signup/check-phone", { phone }, options),

  // Resume abandoned checkout
  resumeCheckout: (email) => api.post("/signup/resume-checkout", { email }),
};

export default api;
